import React from 'react';

import { GoogleLogin } from './components/GoogleLogin';
import './App.css';
import '@elastic/eui/dist/eui_theme_amsterdam_light.min.css';

function App() {
  return (
    <div className="App">
      <GoogleLogin />
    </div>
  );
}

export default App;
